export default "__VITE_ASSET__4b882bef__"